import { axios } from "../../config/axios";

export const classicCampaignAPI = {
  /**
   * Will fetch classic campaign from
   * @param campaignId
   * @returns {Promise<AxiosResponse<any>>}
   */
   fetch(campaignId) {
    return axios.get(`/api/v3/classic_campaigns/${campaignId}`, {
      passthrough: {
        codes: [403]
      }
    }).then((resp) => resp.data);
  },

  /**
   * Updates fields on a campaign
   * @param {number} campaignId
   * @param {object} frag
   * @returns
   */
   patch(campaignId, frag) {
    return axios.patch(`/api/v3/classic_campaigns/${campaignId}`, {
      campaign: frag
    }).then((resp) => resp.data)
  },
};
